import React, { Component } from 'react';
import Button from '@dbk/ui-buttons';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../../components/common/blur-modal';
import Text,{H1} from '@dbk/ui-text';
import { RM_REGION, RM_REGION_CH, RM_REGION_UK } from '../../../constants';
import envConfig from '../../../../db-env-build';
import DbText from '../../../assets/svgs/db-text.js';
class LandingPage extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   email: null,
    //   ipAddress: null
    // };
     this.state = {
      email: null,
      ipAddress: null
    };
  }

  componentDidMount() {
    const emailElement = document.getElementById('loggedInUserEmail');
    const ipAddressElement = document.getElementById('userIPAddress');
    this.setState({
      email: emailElement!=null ?emailElement.value :null,
      ipAddress: ipAddressElement!=null ?ipAddressElement.value :null
    })
  }

  hideGenericErrorModal = () => {
    this.props.rmAccess.setBlurModalError(false);
  }

  handleLoginClick = () => {
    // this is first call for userId so want to send isRMUpdate and moduleName new parameter  for 
    //CH region because need to segregate the RM read only and doc upload user
    /* start */
    let isRMUpdate= true;
    const moduleName = "";
    if(envConfig.rmRegion === "rmch"){
      isRMUpdate = false;
    }
    this.props.rmAccess.setIpAddress(this.state.ipAddress);
    this.props.rmAccess.fetchUserIdDetails(this.state.email, this.state.ipAddress, isRMUpdate, moduleName);
  }

  hideModal = () => {
    this.props.rmAccess.setConfirmationPopup(false);
  }

  onConfirmationClick = () => {
    const { auth: { userId },
      rmAccess: { userAdminGroup } } = this.props;

    this.props.rmAccess.fetchInvalidateSession();
    this.props.rmAccess.fetchRMEntitlements(userAdminGroup, userId);
  }

  showConfirmationModal = () => {
    const { i18n: { messages },
      rmAccess: { confirmationPopup, loading } } = this.props;

    return (
      <BlurModal
        visible={confirmationPopup}
        doneVisible={false}
        backVisible={false}
        testID="blur_modal_test"
        accessibilityLabel="blur_modal_test"
        onDone={() => this.hideModal()}
      >
        <div>
          <div secondary className="modal-error-msg">{messages['app.rmAccess.session.confirmation.popup']}</div>
          <div className="confirmation-modal">
            <Button
              size='large'
              testID="button_ok_message_test"
              accessibilityLabel="button_ok_message_test"
              loading={loading}
              onPress={() => this.onConfirmationClick()} >
              {messages['app.rmAccess.button.continue']}
            </Button>
            <Button
              size='large'
              tertiary
              testID="button_ok_message_test"
              accessibilityLabel="button_ok_message_test"
              onPress={() => this.hideModal()} >
              {messages['app.rmAccess.modal.button.cancel']}
            </Button>
          </div>
        </div>
      </BlurModal>)
  }

  showGenericErrorModal = () => {
    const { i18n: { messages }, rmAccess: { errorMsg } } = this.props;
    return (
      <View >
        <BlurModal
          visible={this.props.rmAccess.showErrorModal}
          doneVisible={false}
          backVisible={false}
          testID="blur_modal_test"
          accessibilityLabel="blur_modal_test"
          headerChildren={<div size="large" secondary>{messages['app.rmAccess.genericErrorTitle']}</div>}
          onDone={() => this.hideGenericErrorModal()}
        >
          <div>
            <div secondary className="modal-error-msg">{errorMsg}</div>
            <div className="margin-top-20 margin-bottom-20 small-12 medium-push-4 medium-4 center">
              <Button
                fullWidth size='large'
                testID="button_ok_message_test"
                accessibilityLabel="button_ok_message_test"
                onPress={() => this.hideGenericErrorModal()} >
                {messages['app.rmAccess.button.ok']}
              </Button>
            </div>
          </div>
        </BlurModal>
      </View>
    )
  }

  getRegionSpecificTitle = () => {
    const {
      i18n: { messages }
    } = this.props;
    switch (envConfig.rmRegion) {
      case RM_REGION_CH:
        return `${messages['app.rmAccess.welcome.subtitle']}`
      case RM_REGION_UK:
        return `${messages['app.rmAccess.uk.welcome.subtitle']}`
      case RM_REGION:
        return `${messages['app.rmAccess.lux.welcome.subtitle']}`
    }
  }

  render() {
    const {
      rmAccess: { showErrorModal, showSpinner, confirmationPopup },
      i18n: { messages }
    } = this.props;
    return (
      <div className="rm-welcome_background">
        <div className="rm-welcome_container">
          <div className="half-container rm-welcome">
            <div className='margin-10'>
              <DbText tabIndex={-1} className={'logo-web'} />
            </div>
            <div className="rm-columns rm-welcome-container">
              <H1 className="rm-welcome-title" tertiary>{messages['app.rmAccess.welcome.title']}</H1>
              <Text size="big" className="rm-welcome-subtitle pad-bottom-100"> {this.getRegionSpecificTitle()} </Text>
              <Button
                className="rm-Button-container"
                testID="button_start_rmAccess_test"
                accessibilityLabel="button_start_rmAccess_test"
                size='medium'
                loading={showSpinner}
                onPress={this.handleLoginClick}
              >{messages['app.rmAccess.login.title']}</Button>
              {showErrorModal && this.showGenericErrorModal()}
              {confirmationPopup && this.showConfirmationModal()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default createContainer({
  $queries: {
    rmAccess: {
      showErrorModal: true,
      errorMsg: true,
      showSpinner: true,
      setBlurModalError: { $set: 'showErrorModal' },
      smartCardUrl: true,
      fetchUserIdDetails: { $call: 'fetchUserIdDetails' },
      confirmationPopup: true,
      setConfirmationPopup: { $set: 'confirmationPopup' },
      fetchInvalidateSession: { $call: 'invalidatePrevSession' },
      loading: true,
      fetchRMEntitlements: { $call: 'fetchRMEntitlements' },
      userAdminGroup: true,
      smartCardLoginFailed: { $call: 'smartCardLoginFailed' },
      setIpAddress: { $set: 'ipAddress' }
    },
    auth: {
      userId: true
    },
    i18n: {
      messages: true,
    }
  },
})(LandingPage);;
